import {User} from 'oidc-client-ts';
import {STORAGE_KEYS} from '../Constants/AppConstants';
import {IGeneralHelperService} from './Interfaces/IGeneralHelperService';
import {ILocalStorageService} from './Interfaces/ILocalStorageService';
import LocalStorageService from './LocalStorageService';

//General miscellaneous helper functions
class GeneralHelperService implements IGeneralHelperService {
  //Check if browser is safari
  isSafari(): boolean {
    let isSafari =
      !!navigator.vendor &&
      navigator.vendor.indexOf('Apple') > -1 &&
      !!navigator.userAgent &&
      navigator.userAgent.indexOf('CriOS') == -1 &&
      navigator.userAgent.indexOf('FxiOS') == -1;

    return isSafari;
  }

  getCurrentUserRoles = (): string[] => {
    const storageService: ILocalStorageService = new LocalStorageService();
    let oidcAuth = storageService.getOidc();

    if (!oidcAuth) return [];

    let user = User.fromStorageString(oidcAuth);
    let jwt = user.access_token;

    if (!jwt) return [];

    let jwtRoles = this.getRolesFromJwt(jwt);
    return jwtRoles;
  };

  getRolesFromJwt = (jwt: string): string[] => {
    try {
      let split = jwt.split('.');
      let decodedPayload = JSON.parse(atob(split[1]));

      if (typeof decodedPayload.roles === 'string') {
        decodedPayload.roles = [decodedPayload.roles];
      }

      return decodedPayload.roles as string[];
    } catch {
      //TODO:fail parsing jwt
    }

    return [];
  };

  getTemplateIcon = (iconSvg: string, primaryColor: string, secondaryColor: string): string => {
    return iconSvg
      .replaceAll('primaryColor', primaryColor)
      .replaceAll('secondaryColor', secondaryColor);
  };
}

export default GeneralHelperService;
